class ReportToolTip {
  constructor() {
    this.initTooltip();
    this.hideDelay = 3000;
    this.visible = false;
    jQuery(".content-wrapper").on("scroll", () => {
      this.hide();
    });

    // Remove tool tip if you click outside of it, and if its visible
    jQuery(document).on("click", (event) => {
      if (!jQuery(event.target).closest(this.tooltip.node()).length) {
        if (jQuery(this.tooltip.node()).is(":visible")) {
          this.hide();
        }
      }
    });
  }

  initTooltip() {
    this.tooltip = d3.select("body").append("div").attr("class", "reports-tooltip").style("opacity", 0);
  }

  show(anchor, tooltipHTML, graphType, entryPoint) {
    this.hide();
    this.visible = true;
    this.anchor = anchor;
    this.tooltip.style("display", "block");
    this.tooltip.transition().duration(200).style("opacity", 1);
    var mouseCover = graphType === "event" ? "<div class='tooltip-mouse-cover'></div>" : "";
    this.tooltip.html(tooltipHTML + mouseCover);

    var tooltipRect = this.tooltip.node().getBoundingClientRect();
    var anchorRect = anchor.getBoundingClientRect();
    jQuery(this.tooltip.node()).trigger("tooltip:show", graphType);
    if (graphType === "event") {
      this.eventToolTip(tooltipRect, anchorRect, entryPoint);
    } else {
      this.valueToolTip(tooltipRect, anchorRect);
    }
  }

  valueToolTip(tooltipRect, anchorRect) {
    var offset = this.metricChartTooltipPlacementOffset(tooltipRect, anchorRect);

    if (offset === "center") {
      this.tooltip
        .attr("class", "reports-tooltip")
        .attr("data-offset", "none")
        .style("left", anchorRect.left - tooltipRect.width / 2 + (anchorRect.right - anchorRect.left) / 2 + "px")
        .style("top", anchorRect.top - tooltipRect.height - 15 + "px");
    } else if (offset === "left") {
      this.tooltip
        .attr("class", "reports-tooltip tooltip-left")
        .attr("data-offset", "none")
        .style("left", anchorRect.left + 25 + "px")
        .style("top", anchorRect.top - tooltipRect.height / 2 + "px");
    } else {
      this.tooltip
        .attr("class", "reports-tooltip tooltip-right")
        .attr("data-offset", "none")
        .style("left", anchorRect.left - tooltipRect.width - 25 + "px")
        .style("top", anchorRect.top - tooltipRect.height / 2 + "px");
    }
  }

  eventToolTip(tooltipRect, anchorRect, entryPoint) {
    var offset = this.eventChartTooltipPlacementOffset(tooltipRect, anchorRect, entryPoint);
    this.tooltip.style("top", anchorRect.top - tooltipRect.height - 15 + "px").attr("class", "reports-tooltip");

    if (offset === "center") {
      this.tooltip
        .style("left", anchorRect.left - tooltipRect.width / 2 + (anchorRect.right - anchorRect.left) / 2 + "px")
        .attr("data-offset", "none");
    } else if (offset === "center-entry") {
      var placement = entryPoint - tooltipRect.width / 2;
      this.tooltip
        .attr("class", "reports-tooltip event-tooltip-mouse-enter")
        .style("left", placement + "px")
        .attr("data-offset", "none");
    } else if (offset === "left") {
      this.tooltip.style("left", anchorRect.left + "px").attr("data-offset", "left");
    } else if (offset === "right") {
      this.tooltip.style("left", anchorRect.right - tooltipRect.width + "px").attr("data-offset", "right");
    }
  }

  metricChartTooltipPlacementOffset(tooltipRect, anchorRect) {
    var withinLeftSide = anchorRect.left > tooltipRect.width / 2;
    var withinRightSide = anchorRect.right + tooltipRect.width / 2 < this.anchor.closest("svg").width.baseVal.value;
    var spaceBetween = anchorRect.width >= tooltipRect.width;

    if ((withinLeftSide && withinRightSide) || spaceBetween) {
      // If tooltip appears within graph on both sides
      return "center";
    } else if (!withinLeftSide) {
      // If tooltip overflows on the left side
      return "left";
    } else {
      // If tooltip overflows on the right side
      return "right";
    }
  }

  eventChartTooltipPlacementOffset(tooltipRect, anchorRect, entryPoint) {
    var tooSmall = anchorRect.width < tooltipRect.width;
    var withinLeftSide = entryPoint > tooltipRect.width / 2;
    var withinRightSide = anchorRect.right + tooltipRect.width / 2 < this.anchor.closest("svg").width.baseVal.value;
    var spaceBetween =
      anchorRect.right - entryPoint >= tooltipRect.width && anchorRect.left + entryPoint >= tooltipRect.width;

    if ((withinLeftSide && withinRightSide) || spaceBetween) {
      // If tooltip appears within graph on both sides
      if (tooSmall) {
        return "center";
      } else {
        return "center-entry";
      }
    } else if (!withinLeftSide) {
      // If tooltip overflows on the left side
      return "left";
    } else if (!withinRightSide) {
      // If tooltip overflows on the right side
      return "right";
    } else {
      return "center";
    }
  }

  hide(transitionTime) {
    transitionTime = typeof transitionTime != "undefined" ? transitionTime : 200;
    var self = this;
    this.tooltip
      .transition()
      .duration(transitionTime)
      .style("opacity", 0)
      .on("end", function () {
        self.tooltip.style("display", "none");
      });
  }

  shouldHideTooltip() {
    return jQuery(this.tooltip.node()).filter(":hover").length === 0;
  }
}

window.ReportToolTip = ReportToolTip;
